import React, { useState } from 'react';
import ClinicLayout from './ClinicLayout';
import { Edit, Trash2, Printer } from 'lucide-react';

const ClinicPatientVisits = () => {
  const [visits] = useState([
    { visitId: 'V001', visitType: 'Office Visit', visitDate: '01/26/2026', patientName: 'Smith, John', patientDOB: '05/15/1975', provider: 'Dr. Williams', status: 'Completed', charges: 250.00, balances: 0.00, primaryIns: 'BCBS / CLM001', secondaryIns: '' },
    { visitId: 'V002', visitType: 'New Patient', visitDate: '01/26/2026', patientName: 'Johnson, Mary', patientDOB: '08/22/1980', provider: 'Dr. Williams', status: 'In Progress', charges: 175.00, balances: 175.00, primaryIns: 'Aetna / CLM002', secondaryIns: '' },
  ]);

  return (
    <ClinicLayout activeTab="patient-visits">
      <div className="p-4 pr-20" data-testid="clinic-patient-visits">
        {/* Sub Navigation Tabs */}
        <div className="flex items-center border-b border-gray-300 mb-4">
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Add New Visit</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-white -mb-px">Patient Visit List</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Patient Look Up</button>
          <button className="px-3 py-2 text-xs border border-gray-300 border-b-0 bg-gray-200">Reports</button>
        </div>

        {/* Section Header */}
        <div className="bg-gradient-to-b from-[#4a5568] to-[#2d3748] text-white px-3 py-2 text-sm font-medium mb-4">
          Patient Visit List
        </div>

        {/* Filters */}
        <div className="bg-[#f5f5f5] border border-gray-300 p-3 mb-4">
          <div className="space-y-2 text-xs">
            {/* Row 1 */}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <label className="w-16">Visit Date:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>By Date</option>
                </select>
                <input type="text" className="border border-gray-400 px-1 py-0.5 w-20" placeholder="01/26/2026" />
              </div>
            </div>
            
            {/* Row 2 */}
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <label className="w-16">Search For:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>Patient Last Name</option>
                </select>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>Starts With</option>
                </select>
                <input type="text" className="border border-gray-400 px-1 py-0.5 w-32" />
                <button className="border border-gray-400 px-3 py-0.5 bg-gray-100">Search</button>
              </div>
            </div>

            {/* Row 3 - Display Filters */}
            <div className="flex items-center gap-4 flex-wrap">
              <span className="font-medium">Display Filter:</span>
              <div className="flex items-center gap-2">
                <label>Office:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <label>Provider:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <label>Status:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <label>Visit Type:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <label>Balance:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <label>Balance Responsibility:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="border border-gray-300">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-[#1e3a5f] text-white">
                <th className="p-1 border border-gray-400 text-left">Visit ID</th>
                <th className="p-1 border border-gray-400 text-left">Visit Type</th>
                <th className="p-1 border border-gray-400 text-left">Visit Date</th>
                <th className="p-1 border border-gray-400 text-left">Patient Name</th>
                <th className="p-1 border border-gray-400 text-left">Patient DOB</th>
                <th className="p-1 border border-gray-400 text-left">Provider</th>
                <th className="p-1 border border-gray-400 text-left">Status</th>
                <th className="p-1 border border-gray-400 text-right">Charges</th>
                <th className="p-1 border border-gray-400 text-right">Balances</th>
                <th className="p-1 border border-gray-400 text-center">Print BST</th>
                <th className="p-1 border border-gray-400 text-left">Primary Insurance/Claim No</th>
                <th className="p-1 border border-gray-400 text-left">Secondary Insurance/Claim No</th>
                <th className="p-1 border border-gray-400 text-center">Edit</th>
                <th className="p-1 border border-gray-400 text-center">Del</th>
              </tr>
            </thead>
            <tbody>
              {visits.map((visit, index) => (
                <tr key={visit.visitId} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="p-1 border border-gray-300 text-[#2563eb] cursor-pointer hover:underline">{visit.visitId}</td>
                  <td className="p-1 border border-gray-300">{visit.visitType}</td>
                  <td className="p-1 border border-gray-300">{visit.visitDate}</td>
                  <td className="p-1 border border-gray-300 font-medium">{visit.patientName}</td>
                  <td className="p-1 border border-gray-300">{visit.patientDOB}</td>
                  <td className="p-1 border border-gray-300">{visit.provider}</td>
                  <td className="p-1 border border-gray-300">{visit.status}</td>
                  <td className="p-1 border border-gray-300 text-right">${visit.charges.toFixed(2)}</td>
                  <td className="p-1 border border-gray-300 text-right">${visit.balances.toFixed(2)}</td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Printer className="w-3 h-3 inline cursor-pointer text-gray-600" />
                  </td>
                  <td className="p-1 border border-gray-300 text-[#2563eb]">{visit.primaryIns}</td>
                  <td className="p-1 border border-gray-300 text-[#2563eb]">{visit.secondaryIns || '-'}</td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Edit className="w-3 h-3 inline cursor-pointer text-blue-600" />
                  </td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Trash2 className="w-3 h-3 inline cursor-pointer text-red-600" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="mt-3 flex items-center gap-2 text-xs">
          <span>|◀ ◀◀</span>
          <span>Page</span>
          <input type="text" className="border border-gray-400 w-8 text-center" defaultValue="1" />
          <span>of 1</span>
          <span>▶▶ ▶|</span>
          <select className="border border-gray-400 px-1">
            <option>10</option>
          </select>
          <span className="ml-4 text-gray-500">Showing 1 to {visits.length} of {visits.length} entries</span>
        </div>
      </div>
    </ClinicLayout>
  );
};

export default ClinicPatientVisits;
